import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { LOGO_ICON } from "@/lib/data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("cpd_token", data.access_token);
      navigate("/admin/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-lg border border-input bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent";

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted px-5">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-md bg-white border border-border rounded-2xl p-8 shadow-lg">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_ICON} alt="Logo" className="h-14 w-14 object-contain mb-3" />
          <h1 className="font-heading text-2xl text-secondary">Admin Portal</h1>
          <p className="text-sm text-muted-foreground">Cardiac Precision Diagnostics</p>
        </div>
        {error && <p data-testid="admin-login-error" className="mb-4 text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-4 py-2.5">{error}</p>}
        <div className="space-y-4">
          <div>
            <label className="block text-xs tracking-[0.15em] uppercase font-bold text-muted-foreground mb-2">Email</label>
            <input data-testid="admin-email" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@..." />
          </div>
          <div>
            <label className="block text-xs tracking-[0.15em] uppercase font-bold text-muted-foreground mb-2">Password</label>
            <input data-testid="admin-password" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
        </div>
        <button data-testid="admin-login-submit" disabled={loading} className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-primary py-3.5 text-sm font-bold text-white hover:bg-secondary transition-colors duration-200 disabled:opacity-70">
          {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={16} />}
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
